import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import { SURFACE_SX, tableSx } from './layoutStyles';
import { WS_CONTROL } from './tokens';

export interface DataSurfaceProps {
  children: ReactNode;
  /** Pixel height of body rows. */
  rowHeight?: number;
  /** Pin each row's `th[scope=row]` while scrolling sideways (grids and matrices). */
  stickyFirstColumn?: boolean;
  /** Names the scroll region when it is not itself a table (grids, matrices). */
  label?: string;
}

/**
 * The scroll box every table in the workspace sits in: fills the data region it is given, is the
 * ONLY thing that scrolls on its screen, is keyboard focusable, and carries the one table style
 * (`tableSx`). `RegistryTable`, `FinancialGrid` and `ComparisonMatrix` all render through it.
 */
export function DataSurface({
  children,
  rowHeight = WS_CONTROL.rowHeight,
  stickyFirstColumn = false,
  label,
}: DataSurfaceProps) {
  return (
    <Box
      tabIndex={0}
      role={label ? 'region' : undefined}
      aria-label={label}
      sx={{
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        overflow: 'auto',
        ...SURFACE_SX,
        ...tableSx(rowHeight, stickyFirstColumn),
      }}
    >
      {children}
    </Box>
  );
}
